module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("If you see this page, something went wrong.")]), _vm._v(" "), _c('div', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "30%",
      "viewBox": "0 0 64 64",
      "enable-background": "new 0 0 64 64"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "32",
      "cy": "32",
      "r": "30",
      "fill": "#ffdd67"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#ff717f"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "52.8",
      "cy": "37.1",
      "r": "8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "11.2",
      "cy": "37.1",
      "r": "8"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#917524"
    }
  }, [_c('path', {
    attrs: {
      "d": "m54.6 20.6c-2.7-3.3-6.7-5.1-11-5.1-.6 0-.7-2.2 0-2.2 4.9 0 9.5 2.1 12.7 5.9.5.6-1.3 1.9-1.7 1.4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m20.3 15.4c-4.2 0-8.3 1.9-11 5.1-.4.5-2.1-.8-1.7-1.4 3.1-3.8 7.8-5.9 12.7-5.9.7 0 .6 2.2 0 2.2"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "32",
      "cy": "49.5",
      "r": "4.5",
      "fill": "#664e27"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m29.5 29.1c0 5-4 9-9 9-5 0-9-4-9-9 0-5 4-9 9-9 5 0 9 4.1 9 9",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "20.5",
      "cy": "29.1",
      "r": "4.5",
      "fill": "#664e27"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m52.5 29.1c0 5-4 9-9 9-5 0-9-4-9-9 0-5 4-9 9-9 5 0 9 4.1 9 9",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "43.5",
      "cy": "29.1",
      "r": "4.5",
      "fill": "#664e27"
    }
  })])]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Logout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Emoji provided for free by "), _c('a', {
    attrs: {
      "href": "http://emojione.com",
      "target": "_blank"
    }
  }, [_vm._v("EmojiOne")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0984388"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/authentication/Logout.vue
// module id = 632
// module chunks = 1